var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 418,
    viewBox: "0 0 166 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 138.079,
    height: 138.079,
    rx: 20,
    transform: "matrix(0.706265 0.707947 0.706265 -0.707947 -97.8672 320.248)",
    fill: "#115E99"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 233.133,
    height: 233.133,
    rx: 20,
    transform: "matrix(0.708 0.706213 0.708 -0.706213 -165 164.641)",
    fill: "#1367A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackground);
export default __webpack_public_path__ + "static/media/auth_background.2eaf603b80417928e737cb4ffdbaace3.svg";
export { ForwardRef as ReactComponent };